import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';
import {
  ActionProps,
  ActionWithRulesAndAddersProps,
  ActionWithRulesProps,
  CombinatorSelectorProps,
  RuleGroupType,
  RuleType,
} from 'react-querybuilder';
import { defaultNullRelatedOperators } from './constants';

const removeSvg = <RMSvgIcon name="Remove" fill="red" />;

export const combinatorSelector = (
  props: React.PropsWithChildren<CombinatorSelectorProps>,
) => {
  const options = { or: 'or', and: 'and' };
  const selectedClassName = props.disabled
    ? 'selectedDisabledCombinator-Button'
    : 'selectedCombinator-Button';
  const defaultClassName = props.disabled
    ? 'disabledCombinator-Button'
    : 'combinator-Button';
  return (
    <div id="querybuilder-utils-combinatorselector-buttons" className="flex flex-row">
      <button
        id={`querybuilder-utils-combinatorselector-${options.and}-button`}
        className={`${
          props.value === options.or ? selectedClassName : defaultClassName
        } leftBorderRadius`}
        onClick={() => props.handleOnChange(options.or)}
      >
        {options.or.toUpperCase()}
      </button>
      <button
        id={`querybuilder-utils-combinatorselector-${options.or}-button`}
        className={`${
          props.value === options.and ? selectedClassName : defaultClassName
        } rightBorderRadius`}
        onClick={() => props.handleOnChange(options.and)}
      >
        {options.and.toUpperCase()}
      </button>
    </div>
  );
};

export const addRuleAction = (
  props: React.PropsWithChildren<ActionWithRulesAndAddersProps>,
) => {
  return (
    <button
      id="querybuilder-utils-add-rule-action"
      className={`${props.className} ${
        props.disabled ? `disabled-Button` : `add-RuleNGroup-Button`
      }`}
      title={'Add New Condition'}
      onClick={(e) => {
        return props.handleOnClick(e);
      }}
    >
      + Condition
    </button>
  );
};

export const addGroupAction = (
  props: React.PropsWithChildren<ActionWithRulesAndAddersProps>,
) => {
  return (
    <button
      id="querybuilder-utils-add-group-action"
      className={`${props.className} ${
        props.disabled ? `disabled-Button` : `add-RuleNGroup-Button`
      }`}
      title={props.title}
      onClick={(e) => {
        return props.handleOnClick(e);
      }}
    >
      + Group
    </button>
  );
};

export const removeGroupAction = (
  props: React.PropsWithChildren<ActionWithRulesProps>,
) => {
  return (
    <button
      id="querybuilder-utils-remove-group-action"
      className={`${props.className} remove-RuleNGroup-Button`}
      onClick={(e) => {
        return props.handleOnClick(e);
      }}
    >
      {removeSvg}
    </button>
  );
};

export const removeRuleAction = (props: React.PropsWithChildren<ActionProps>) => {
  return (
    <button
      id="querybuilder-utils-remove-rule-action"
      className={`${props.className} remove-RuleNGroup-Button`}
      onClick={(e) => {
        return props.handleOnClick(e);
      }}
    >
      {removeSvg}
    </button>
  );
};

// Flatten rules from NON-independant combinators
export const flattenRulesFromNonIC = (query: RuleGroupType): RuleType[] => {
  const rules: RuleType[] = [];

  const traverse = (q: RuleGroupType) => {
    q.rules.forEach((rule) => {
      if ((rule as RuleGroupType).rules) {
        // It's a group, recurse into it
        traverse(rule as RuleGroupType);
      } else {
        // It's a rule, add to the list
        rules.push(rule as RuleType);
      }
    });
  };

  traverse(query);
  return rules;
};
/**
 * checks non-independant combinators constraints list for empty values
 * @param query
 * @returns
 */
export const checkAllRulesFromNonIc = (query: RuleGroupType): boolean => {
  const traverse = (q: RuleGroupType): boolean => {
    return q.rules.every((rule) => {
      if ((rule as RuleGroupType).rules) {
        // It's a group, recurse into it
        return traverse(rule as RuleGroupType);
      } else {
        // It's a rule, check the value
        const r = rule as RuleType;
        if (
          r.operator === defaultNullRelatedOperators.null ||
          r.operator === defaultNullRelatedOperators.notNull
        ) {
          return true;
        }
        return r.value !== undefined && r.value !== null && r.value !== '';
      }
    });
  };

  return traverse(query);
};
